import { MutateTemplateForm } from '../../components/mutate-template-form/mutate-template-form';

export const CreateTemplatePage = () => <MutateTemplateForm mode="create" />;
